import React from "react";
import { Viewer } from "./components/Viewer";
import { HeaderBar } from "./components/HeaderBar";

export default function App() {
    return (
        <div style={{ height: "100dvh" }}>
            <HeaderBar />
            <Viewer height="80%" />
        </div>
    );
}
